<template>
  <div
    style="position: absolute; top: 0px; bottom: 0px; right: 0; transition: .2s ease transform;"
    :style="{
      left: resourceViewer.width > 0 ? 100 - resourceViewer.width + '%' : '10%',
      transform: resourceViewer.width == 0 && hide ? 'translate(85%)' : null
    }"
    :class="`elevation-${resourceViewer.width > 0 ? 2 : 6} white`"
  >
    <import-resource
      v-if="resourceViewer.show && resourceViewer.resourceId == 'import'"
      @close="setResourceViewer({ show: false })"
      @openResource="setResourceViewer({ resourceId: $event, show: true, width: 50 })"
    ></import-resource>
    <resource-viewer
      v-else-if="resourceViewer.show"
      :resourceId="resourceViewer.resourceId"
      @close="setResourceViewer({ show: false })"
    ></resource-viewer>
    <v-row
      class="pa-3"
      no-gutters
      style="position: absolute; left: 0; right: 70px; bottom: 10px; z-index: 2; pointer-events: none;"
    >
      <v-col class="shrink">
        <v-menu>
          <template v-slot:activator="{ on: { click } }">
            <v-btn @click.stop="click" fab small color="white" style="pointer-events: all;">
              <div style="width: 22px; height: 22px; margin-left: -1px;">
                <div
                  :style="
                    `display: inline-block; width: ${100 -
                      resourceViewer.width}%; height: 100%; padding: 1px; overflow: hidden;`
                  "
                >
                  <div
                    :style="
                      `background: ${
                        resourceViewer.width > 0 ? `#bdbbbb` : 'grey'
                      }; height: 100%; width: 100%; border-radius: 2px;`
                    "
                  ></div>
                </div>
                <div
                  :style="
                    `display: inline-block; width: ${resourceViewer.width}%; height: 100%; padding: 1px; overflow: hidden;`
                  "
                >
                  <div
                    style="background: grey; height: 100%; width: 100%; border-radius: 2px;"
                  ></div>
                </div>
              </div>
            </v-btn>
          </template>
          <v-list>
            <template>
              <v-list-item @click="setResourceViewer({ width: 65 })">
                <v-list-item-icon>
                  <div style="width: 22px; height: 22px; margin-left: -1px;">
                    <div
                      style="display: inline-block; width: 35%; height: 100%; padding: 1px; overflow: hidden;"
                    >
                      <div
                        style="background: #bdbbbb; height: 100%; width: 100%; border-radius: 2px;"
                      ></div>
                    </div>
                    <div
                      style="display: inline-block; width: 65%; height: 100%; padding: 1px; overflow: hidden;"
                    >
                      <div
                        style="background: grey; height: 100%; width: 100%; border-radius: 2px;"
                      ></div>
                    </div>
                  </div>
                </v-list-item-icon>
                <v-list-item-title>Large Panel</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setResourceViewer({ width: 50 })">
                <v-list-item-icon>
                  <div style="width: 22px; height: 22px; margin-left: -1px;">
                    <div
                      style="display: inline-block; width: 50%; height: 100%; padding: 1px; overflow: hidden;"
                    >
                      <div
                        style="background: #bdbbbb; height: 100%; width: 100%; border-radius: 2px;"
                      ></div>
                    </div>
                    <div
                      style="display: inline-block; width: 50%; height: 100%; padding: 1px; overflow: hidden;"
                    >
                      <div
                        style="background: grey; height: 100%; width: 100%; border-radius: 2px;"
                      ></div>
                    </div>
                  </div>
                </v-list-item-icon>
                <v-list-item-title>Half Panel</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setResourceViewer({ width: 35 })">
                <v-list-item-icon>
                  <div style="width: 22px; height: 22px; margin-left: -1px;">
                    <div
                      style="display: inline-block; width: 65%; height: 100%; padding: 1px; overflow: hidden;"
                    >
                      <div
                        style="background: #bdbbbb; height: 100%; width: 100%; border-radius: 2px;"
                      ></div>
                    </div>
                    <div
                      style="display: inline-block; width: 35%; height: 100%; padding: 1px; overflow: hidden;"
                    >
                      <div
                        style="background: grey; height: 100%; width: 100%; border-radius: 2px;"
                      ></div>
                    </div>
                  </div>
                </v-list-item-icon>
                <v-list-item-title>Small Panel</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="
                  setResourceViewer({ width: 0 });
                  hide = false;
                "
              >
                <v-list-item-icon>
                  <div style="width: 22px; height: 22px; margin-left: -1px;">
                    <div
                      style="display: inline-block; width: 10%; height: 100%; padding: 1px; overflow: hidden;"
                    >
                      <div
                        style="background: #bdbbbb; height: 100%; width: 100%; border-radius: 2px;"
                      ></div>
                    </div>
                    <div
                      style="display: inline-block; width: 90%; height: 100%; padding: 1px; overflow: hidden;"
                    >
                      <div
                        style="background: grey; height: 100%; width: 100%; border-radius: 2px;"
                      ></div>
                    </div>
                  </div>
                </v-list-item-icon>
                <v-list-item-title>Full Panel</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </v-col>
      <v-col v-if="!resourceViewer.width" class="shrink ml-3">
        <v-btn v-if="!hide" @click="hide = !hide" style="pointer-events: all;"
          >HIDE <v-icon>keyboard_arrow_right</v-icon></v-btn
        >
        <v-btn v-else @click="hide = !hide" style="pointer-events: all;"
          >SHOW <v-icon>keyboard_arrow_left</v-icon></v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ResourceViewer from '@/components/ResourceViewer/index';
import ImportResource from './ImportResource';

import { mapState, mapMutations } from 'vuex';
export default {
  components: { ResourceViewer, ImportResource },
  data() {
    return {
      hide: false
    };
  },
  computed: {
    ...mapState('views/context', ['resourceViewer']),
    resourceViewerModal: {
      get() {
        return this.resourceViewer.show;
      },
      set({ show, resourceId }) {
        this.setResourceViewer({ show, resourceId });
      }
    }
  },
  methods: {
    ...mapMutations('views/context', ['setResourceViewer'])
  }
};
</script>

<style></style>
